// extracted by mini-css-extract-plugin
export default {"steps-main-box":"StepsMain_steps-main-box__ziL9a","img-box":"StepsMain_img-box__7v9UD","fadeInLeft":"StepsMain_fadeInLeft__Sk5Zv"};